<template>
    <div id="app" class="my-0 py-0">
        <v-app id="inspire">
            <v-form ref="form" v-model="valid" :lazy-validation="lazy">
                <v-card v-model="show" class="py-0">
                    <v-toolbar class="py-0 my-0" dark color="green">
                        <v-toolbar-title class="my-0 py-0">Calibración Externa / Ensayo</v-toolbar-title>

                    </v-toolbar>
                </v-card>
                <v-card color="green lighten-4" class="py-0 my-0">
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="6" sm="2" md="2">
                                <v-text-field color="green darken-2" dense v-model="fecha" label="Fecha"></v-text-field>
                            </v-col>
                            <v-col cols="12" sm="6" md="8">
                                <v-select item-color="green" color="green darken-2" dense v-model="equipo"
                                    :items="listadoequipo" label="Equipo" item-text="nombre"
                                    item-value="codgral"></v-select>
                            </v-col>
                            <v-col cols="6" sm="2" md="2">
                                <v-text-field color="green darken-2" dense v-model="numcertificado"
                                    label="N° Certificado"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="6">
                                <v-select item-color="green" color="green darken-2" dense v-model="empresaselect"
                                    :items="listadoempresa" label="Empresa" item-text="empresa" return-object
                                    @change="completarempresa()" item-value="codigo"></v-select>
                            </v-col>
                            <v-col cols="4" sm="2" md="2">
                                <v-text-field color="green darken-2" dense v-model="codigo"
                                    label="Código Empresa"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="4">
                                <v-text-field color="green darken-2" dense v-model="empresa"
                                    label="Empresa"></v-text-field>
                            </v-col>
                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="6" md="4">
                                <v-text-field color="green darken-2" dense v-model="domicilio"
                                    label="Domicilio"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="4">
                                <v-text-field color="green darken-2" dense v-model="telefono"
                                    label="Teléfono / Mail"></v-text-field>
                            </v-col>
                            <v-col cols="6" sm="6" md="4">
                                <v-text-field color="green darken-2" dense v-model="contacto"
                                    label="Contacto"></v-text-field>
                            </v-col>

                        </v-row>
                        <v-row dense>
                            <v-col cols="12" sm="12" md="12">
                                <v-textarea color="green darken-2" auto-grow rows="2" label="Observaciones" dense
                                    v-model="observ"></v-textarea>
                            </v-col>
                        </v-row>
                    </v-card-text>
                </v-card>
                <v-card>
                    <v-card-text>
                        <div>
                            <v-row dense>
                                <v-col cols="12" sm="6" md="6">
                                    <v-file-input color="green darken-2" show-size label="Seleccionar Archivo"
                                        v-model="archivo" @change="selectFiles"></v-file-input>
                                </v-col>
                            </v-row>
                            <v-row dense>
                                <v-col cols="12" sm="4" md="4">
                                    <v-text-field color="green darken-2" v-model="titulo" prepend-icon="mdi-text"
                                        label="Título" maxlength="45" dense
                                        hint="El título debe tener al menos 10 caracteres"></v-text-field>
                                </v-col>
                            </v-row>
                        </div>
                    </v-card-text>
                </v-card>

                <v-card color="green lighten-4" dark tile>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="success" @click.stop="guardar" :disabled="deshabilitar">Guardar</v-btn>

                    </v-card-actions>
                </v-card>
            </v-form>
        </v-app>
    </div>
</template>

<script>
import moment from "moment";
import axios from "../../../../src/axios-auth";
export default {
    data: (vm) => ({
        fecha: moment().format("DD/MM/YYYY"),
        equipo: "",
        listadoequipo: [],
        codgral: "",
        codigo: "",
        numcertificado: "",
        empresa: "",
        empresaselect: "",
        listadoempresa: [],
        selectedIndex: '',
        domicilio: "",
        contacto: "",
        telefono: "",
        observ: "",
        valid: false,
        validsubir: false,
        deshabilitar: false,
        lazy: false,
        selectedFiles: "",
        progressInfos: [],
        archivo: [],
        rulesarchivos: [
            (value) =>
                !value || value.size < 3000000 || "Las fotos deben pesar 3MB o menos",
        ],
        requiredRules: [(v) => !!v || "Dato obligatorio"],
        selectedFiles: null,
        progressInfos: [],
        message: "",
        titulo: "",
        titulofoto: "",
        fileInfos: [],
        archivo: null,
    }),
    watch: {
        titulo(val) {
            if (this.titulo.length > 3 && this.tipo != null && this.tipo != "") {
                this.validsubir = true;
            } else {
                this.validsubir = false;
            }
        },


    },
    computed: {

        show: {
            get() {
                this.cargarEquipo();
                this.cargarEmpresa();
            },
            set(value) {
                if (!value) {
                    this.vaciarModels();
                    this.$refs.form.resetValidation();
                    document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
                    this.$emit("close");
                }
            },
        },
    },

    methods: {
        cargarEquipo() {
            let self = this;
            axios
                .get("/SSGG/CargarEquipos?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.listadoequipo = response.data;
                })
                .catch((error) => {
                    self.listadoequipo = "";
                    console.log(error);
                });
        },
        cargarEmpresa() {
            let self = this;
            axios
                .get("/SSGG/CargarEmpresas?", {
                    params: {
                    },
                })
                .then((response) => {
                    self.listadoempresa = response.data;
                })
                .catch((error) => {
                    self.listadoempresa = "";
                    console.log(error);
                });
        },

        completarempresa() {
            this.codigo = this.empresaselect.codigo;
            this.empresa = this.empresaselect.empresa;
            this.domicilio = this.empresaselect.domicilio;
            this.telefono = this.empresaselect.telefono;
            this.contacto = this.empresaselect.contacto;
        },

        selectFiles(files) {
            this.selectedFiles = files;
        },
        vaciarModels() {
            this.equipo = "";
            this.empresa = "";
            this.domicilio = "";
            this.contacto = "";
            this.numcertificado = "";
            this.telefono = "";
            this.observ = "";
            this.selectedFiles = null;
            this.titulo = "";
            this.archivo = "";
            this.$router.push({ name: "MainInspeccion" });
        },

        guardar() {
            this.deshabilitar = true;
            const codigo = this.codgral;
            let self = this;
            let formData = new FormData();
            if (this.selectedFiles != null) {
                formData.append("path", self.selectedFiles, self.selectedFiles.name);
            }
            formData.append("titulo", self.titulo);
            formData.append("descripcion", "");
            formData.append("codgral", self.equipo)
            formData.append("codigo", self.codigo)
            formData.append("empresa", self.empresa)
            formData.append("domicilio", self.domicilio)
            formData.append("contacto", self.contacto)
            formData.append("telefono", self.telefono)
            formData.append("fecha", self.fecha)
            formData.append("numcertificado", self.numcertificado)
            formData.append("observ", self.observ)

            axios
                .post("SSGG/GuardarCalibexterna", formData, {
                    headers: {
                        "Content-Type": "multipart/form-data",
                    },
                })
                .then((response) => {

                    self.$refs.form.resetValidation();

                    self.showAlert({
                        icon: "success",
                        title: "Calibración externa guardada con éxito",
                        vm: self,
                    });
                    self.vaciarModels();
                    self.$emit("close");
                })

        },



        showAlert(alertInfo) {
            alertInfo.vm.$swal.fire({
                icon: alertInfo.icon,
                title: alertInfo.title,
                showConfirmButton: false,
                background: "#ececec",
                timer: 2000,
            });
        },
    },
};
</script>
